import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'th', label: 'ไทย', short: 'TH' },
  { code: 'en', label: 'ENG', short: 'EN' },
] as const;

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'th').slice(0, 2);

  return (
    <div
      className="inline-flex items-center h-9 gap-0.5 rounded-xl border border-gray-200/70 bg-gray-100/60 p-0.5
                 dark:border-slate-700/70 dark:bg-slate-800"
      role="group"
      aria-label="Language"
    >
      {LANGS.map((l) => {
        const active = current === l.code;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => i18n.changeLanguage(l.code)}
            aria-pressed={active}
            title={l.code === 'th' ? 'เปลี่ยนเป็นภาษาไทย' : 'Switch to English'}
            className={`flex items-center h-full px-3 rounded-lg text-xs font-bold tracking-wide transition-all duration-200 ${
              active
                ? 'bg-white text-gray-800 shadow-sm dark:bg-slate-600 dark:text-slate-100'
                : 'text-gray-400 hover:text-gray-600 dark:text-slate-500 dark:hover:text-slate-300'
            }`}
          >
            {l.short}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
